// Finance reports API (slice 3): the slicer (TD-076) and the Clients tab's facts. Admin only, like the
// ledger API: the admin apiClient, which throws an HttpError carrying the server's message on a 4xx.
import { apiClient } from "@/services/apiClient";
import type { ClientsResponse } from "../types";

const BASE = "/api/finance";

export const reportService = {
  clients: () => apiClient.get<ClientsResponse>(`${BASE}/clients`),
};
